import React, { useState } from 'react';
import classNames from 'classnames';
import useTranslations from '@/hooks/translations';
import Text from '../../../app/Text';
import styles from './styles';
import useInterval from '../../../../hooks/interval';
import useThemeListener from '../../../../hooks/themeListener';

export default function TherapistsCounter({ className, style, user }) {
  const [tracksCount, setTracksCount] = useState(0);
  const [coachesCount, setCoachesCount] = useState(0);
  const { isDark } = useThemeListener();
  const trackCountLimit = 1000;
  const trackCountIncrement = 8;
  const trackCountDelay = 35;
  const coachesCountLimit = 100;
  const coachCountDelay = 45;
  const { t } = useTranslations();

  useInterval(
    () => {
      setTracksCount(tracksCount + trackCountIncrement);
    },
    tracksCount >= trackCountLimit ? null : trackCountDelay
  );
  useInterval(
    () => {
      setCoachesCount(coachesCount + 1);
    },
    coachesCount >= coachesCountLimit ? null : coachCountDelay
  );

  return (
    <div className={`${className}`}>
      <div
        className={classNames('col', {
          'card-dark': isDark,
          card: !isDark,
          animation: true,
        })}
        style={style}>
        <Text
          color="b100"
          type={'h4-large'}
          component="h1"
          weight={'regular'}
          align="left"
          style={{
            marginTop: 0,
            marginBottom: 2,
          }}>
          {!user?.personalizePlan
            ? t('onboarding_your_plan_your_personalized_plan_exp', {
                ns: 'yourplan',
              })
            : t('onboarding_your_plan_your_personalized_plan', {
                ns: 'yourplan',
              })}
        </Text>
        <Text
          color={isDark ? 'b64' : 'g50'}
          type={'body'}
          weight="regular"
          align="left">
          {t('onboarding_your_plan_analyzed_responses', { ns: 'yourplan' })}
        </Text>
        <div className={classNames('counter-container')}>
          <div>
            <div className={classNames('tracks_counter')}>
              <Text type={'h2'} align="left" color="b100" weight="bold">
                {t('counter_text', { count: tracksCount })}
              </Text>
            </div>
            <Text
              type={'body'}
              align="left"
              color={isDark ? 'b100' : 'g100'}
              weight="regular"
              style={{
                maxWidth: 123,
              }}>
              {t('onboarding_your_plan_tracks_to_use', { ns: 'yourplan' })}
            </Text>
          </div>
          <div>
            <div className={classNames('therapists_counter')}>
              <Text type="h2" align="left" color="b100" weight="bold">
                {t('counter_text', { count: coachesCount })}
              </Text>
            </div>
            <Text
              type="body"
              align="left"
              color={isDark ? 'b100' : 'g100'}
              weight="regular"
              style={{
                maxWidth: 123,
              }}>
              {t('onboarding_your_plan_therapists', { ns: 'yourplan' })}
            </Text>
          </div>
        </div>
        <style jsx>{styles}</style>
      </div>
    </div>
  );
}
